import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  private loading: boolean = false;
  private text: string = 'Procesando...';

  constructor() {}

  setText(loading: boolean) {
    this.loading = loading;
  }

  setLoading(loading: boolean, text?: string) {
    this.loading = loading;

    if (loading) {
      document.body.style.overflow = 'hidden';

      if (!!text) {
        this.text = text;
      } else {
        this.text = 'Procesando...';
      }
    } else {
      document.body.style.overflow = 'auto ';
    }
  }

  getLoading(): boolean {
    return this.loading;
  }

  getText(): string {
    return this.text;
  }
}
